import React, { useEffect, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import debounce from 'lodash.debounce';
import airbnb from '../../assets/airbnb.svg';
import Booking from '../../assets/b.svg';
import agoda from '../../assets/agoda.svg';
import direct from '../../assets/direct.svg';
import whatsApp from '../../assets/whatsApp.svg';
import vrbo from '../../assets/vrbo.png';
import { getAllConversations, searchConversations } from '../../helper/backend_helper';
import Iconify from '../iconify';

const Sidebar = ({ onChatSelect, setnewChatModalOpen }) => {
  const [conversations, setConversations] = useState([]);

  const [filterTagConversation, setFilteredTagConversation] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedOption, setSelectedOption] = useState('');
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  // Debounced API call
  const fetchSearchResults = debounce(async (query) => {
    if (!query.trim()) {
      setConversations([]);
      fetchData(1);
      return;
    }

    try {
      const response = await searchConversations(query);
      setConversations(response?.data?.data);
      setFilteredTagConversation(response?.data?.data);
    } catch (error) {
      console.error('Error fetching search results:', error);
    }
  }, 500); // 500ms debounce delay

  // Effect to call the debounced function whenever searchTerm changes
  useEffect(() => {
    fetchSearchResults(searchTerm);

    // Cleanup function to cancel the debounce when the component unmounts or the searchTerm changes
    return () => {
      fetchSearchResults.cancel();
    };
  }, [searchTerm]);

  // const [loadMoreLoading, setLoadMoreLoading] = useState(false);
  // console.log(selectedOption)
  // console.log(conversations);
  // const filteredConversation = conversations?.filter(
  //   (item) =>
  //     item?.user?.guestName?.toLowerCase().includes(searchTerm.toLowerCase()) || item?.contactNo?.includes(searchTerm)
  // );
  // console.log(filteredConversation);

  const handleImage = (channel) => {
    switch (channel) {
      case 'airbnb':
        return airbnb;
      case 'booking':
        return Booking;
      case 'agoda':
        return direct;
      case 'direct':
        return agoda;
      case 'be':
        return agoda;
      case 'homeaway':
        return vrbo;
      default:
        return ''; // Return a default or fallback image if `cod_channel` doesn't match
    }
  };

  async function fetchData(pageNumber = 1) {
    try {
      setLoading(true);
      const response = await getAllConversations(pageNumber);
      const newConversations = response?.data?.data;

      const total = response?.data?.total;
      setConversations(newConversations);
      // setConversations((prev) => [...prev, ...newConversations]);
      setFilteredTagConversation((prev) => [...prev, ...newConversations]);

      if (conversations.length + newConversations.length >= total) {
        setHasMore(false); // No more conversations to load
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  }
  const handleLoadMore = () => {
    if (hasMore) {
      setPage((prev) => prev + 1);
      fetchData(page + 1);
    }
  };

  const handleStatus = (data) => {
    const today = new Date();
    const checkInDate = new Date(data.checkInDate);
    const checkOutDate = new Date(data.checkOutDate);

    if (data.checkInStatus === 'CANC') {
      return { status: 'Cancelled', bgColor: 'bg-[#AEAEB4]' };
    }
    const phoneOccurrences = conversations?.filter((conversation) => conversation?.user?.phone === data?.phone);

    if (today < checkInDate) {
      return { status: 'Future', bgColor: 'bg-[#70D4FF]' };
    }

    if (today.toDateString() === checkInDate.toDateString()) {
      return { status: 'Checkin', bgColor: 'bg-[#C5CC00]' };
    }

    if (today > checkInDate && today < checkOutDate) {
      return { status: 'Staying', bgColor: 'bg-[#7FCD5D]' };
    }

    if (today.toDateString() === checkOutDate.toDateString()) {
      return { status: 'Checkout', bgColor: 'bg-[#FFA500]' };
    }

    if (today > checkOutDate) {
      return { status: 'Past Guest', bgColor: 'bg-[#AEAEB4]' };
    }
    if (phoneOccurrences?.length >= 2) {
      return { status: 'Multiple', bgColor: 'bg-[#FBE581]' };
    }
    // Ensure a default return to satisfy consistent-return rule
    return { status: 'Unknown', bgColor: 'bg-gray-300' };
  };

  const handleChatClick = (chat) => {
    onChatSelect(chat);
    console.log('Clicked chat:', chat);
    // Update unReadCount of the clicked conversation only
    const updatedConversations = conversations.map((conv) =>
      conv._id === chat._id ? { ...conv, unReadCount: 0 } : conv
    );

    setConversations(updatedConversations);
  };

  useEffect(() => {
    fetchData(1);
  }, []);

  const handleFilter = (tag) => {
    console.log(tag);
    if (tag === '') {
      fetchData();
    }
    if (tag === 'multiple') {
      // Step 1: Count occurrences of each phone number
      const phoneCounts = {};
      filterTagConversation.forEach((conversation) => {
        const phone = conversation?.user?.phone;
        if (phone) {
          phoneCounts[phone] = (phoneCounts[phone] || 0) + 1;
        }
      });

      // Step 2: Filter conversations with phone numbers appearing 2 or more times
      const filteredByPhone = filterTagConversation.filter(
        (conversation) => conversation?.user?.phone && phoneCounts[conversation?.user?.phone] >= 2
      );

      // Update your `filteredConversation` or state as needed
      console.log('Filtered Conversations:', filteredByPhone);
      setConversations(filteredByPhone); // Assume you have `setFilteredConversation` state handler
    }
    if (tag === 'past_guest') {
      // Step 1: Filter conversations with check-out date strictly in the past
      const filteredByCheckOutDate = filterTagConversation.filter((conversation) => {
        const checkOutDate = new Date(conversation?.user?.checkOutDate);
        const today = new Date();
        return checkOutDate < today.setHours(0, 0, 0, 0); // Compare only the date part
      });

      // Update your `filteredConversation` or state as needed
      console.log('Filtered Conversations:', filteredByCheckOutDate);
      setConversations(filteredByCheckOutDate); // Assume you have `setConversations` state handler
    }
    if (tag === 'future') {
      // Step 1: Filter conversations with check-out date strictly in the past
      const filteredByCheckInDate = filterTagConversation.filter((conversation) => {
        const checkInDate = new Date(conversation?.user?.checkInDate);
        const today = new Date();
        return checkInDate > today.setHours(0, 0, 0, 0); // Compare only the date part
      });

      // Update your `filteredConversation` or state as needed
      console.log('Filtered Conversations:', filteredByCheckInDate);
      setConversations(filteredByCheckInDate); // Assume you have `setConversations` state handler
    }

    if (tag === 'checkin') {
      // Step 1: Filter conversations with check-in date strictly in the past
      const filteredByCheckInDate = filterTagConversation.filter((conversation) => {
        const checkInDate = new Date(conversation?.user?.checkInDate);
        const today = new Date();
        return checkInDate.toDateString() === today.toDateString(); // Compare only the date part
      });

      // Update your `filteredConversation` or state as needed
      console.log('Filtered Conversations:', filteredByCheckInDate);
      setConversations(filteredByCheckInDate); // Assume you have `setConversations` state handler
    }

    if (tag === 'checkout') {
      // Step 1: Filter conversations with check-out date strictly in the past
      const filteredByCheckOutDate = filterTagConversation.filter((conversation) => {
        const checkOutDate = new Date(conversation?.user?.checkOutDate);
        const today = new Date();
        return checkOutDate.toDateString() === today.toDateString(); // Compare only the date part
      });

      // Update your `filteredConversation` or state as needed
      console.log('Filtered Conversations:', filteredByCheckOutDate);
      setConversations(filteredByCheckOutDate); // Assume you have `setConversations` state handler
    }

    if (tag === 'staying') {
      // Step 1: Filter conversations with check-out date strictly in the past
      const filteredByStaying = filterTagConversation.filter((conversation) => {
        const checkInDate = new Date(conversation?.user?.checkInDate);
        const checkOutDate = new Date(conversation?.user?.checkOutDate);
        const today = new Date();
        return checkInDate < today && checkOutDate > today; // Compare only the date part
      });

      // Update your `filteredConversation` or state as needed
      console.log('Filtered Conversations:', filteredByStaying);
      setConversations(filteredByStaying); // Assume you have `setConversations` state handler
    }

    if (tag === 'cancelled') {
      // Step 1: Filter conversations with check-in status as 'CANC'
      const filteredByCancelled = filterTagConversation.filter(
        (conversation) => conversation?.user?.checkInStatus === 'CANC'
      );

      // Update your `filteredConversation` or state as needed
      console.log('Filtered Conversations:', filteredByCancelled);
      setConversations(filteredByCancelled); // Assume you have `setConversations` state handler
    }

    if (tag === 'request') {
      // Step 1: Filter conversations with check-in status as 'CANC'
      const filteredByRequest = filterTagConversation.filter((conversation) => conversation?.user == null);

      // Update your `filteredConversation` or state as needed
      console.log('Filtered Conversations:', filteredByRequest);
      setConversations(filteredByRequest); // Assume you have `setConversations` state handler
    }
    if (tag === 'emergency') {
      const filteredByEmergency = filterTagConversation?.filter(
        (conversation) => conversation?.user?.manual_status === 'Emergency'
      );
      setConversations(filteredByEmergency);
    }
    if (tag === 'badReview') {
      const filteredByBadReview = filterTagConversation?.filter(
        (conversation) => conversation?.user?.manual_status === 'Bad Review'
      );
      setConversations(filteredByBadReview);
    }
    if (tag === 'cash') {
      const filteredByCash = filterTagConversation?.filter(
        (conversation) => conversation?.user?.manual_status === 'Cash'
      );
      setConversations(filteredByCash);
    }
  };

  return (
    <div className=" bg-gray-100 h-[90vh] overflow-y-auto p-4 scrollbar-hide">
      {/* Search Bar */}
      <div className=" relative">
        {/* Search Icon */}
        <span className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
          <svg
            className="w-3 h-3 text-gray-400"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35M10 18a8 8 0 100-16 8 8 0 000 16z" />
          </svg>
        </span>

        {/* Input Field */}
        <input
          type="text"
          placeholder="Search chat"
          className="w-full text-sm p-1 placeholder:text-xs pl-8 border outline-none border-none rounded-lg"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)} // Update search term
        />
      </div>
      <div className="my-2 border-b-[1px] border-gray-300 " />
      {/* Filter Tags */}

      <div className="flex my-2 gap-2">
        <p className="text-sm">Filter tag:</p>
        <div>
          <select
            id="countries"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            onChange={(e) => {
              setSelectedOption(e.target.value);
              handleFilter(e.target.value);
            }}
            value={selectedOption}
          >
            <option value="" selected>
              Choose an option
            </option>
            <option value="past_guest">Past Guest</option>
            <option value="multiple">Multiple</option>
            <option value="future">Future</option>
            <option value="checkin">Checkin</option>
            <option value="checkout">Checkout</option>
            <option value="staying">Staying</option>
            <option value="cancelled">Cancelled</option>
            <option value="request">Request</option>
            <option value="emergency">Emergency</option>
            <option value="badReview">Bad Review</option>
            <option value="cash">Cash</option>
          </select>
        </div>
        <button
          onClick={() => setnewChatModalOpen(true)}
          className="bg-blue-600 text-white text-xs px-3 py-1 rounded-lg hover:bg-blue-700 transition-colors"
        >
          Start Chat
        </button>
      </div>

      {/* Chat List */}
      {/* {loading && (
        <div className="flex justify-center items-center h-full">
          <CircularProgress size="2rem" color="error" />
        </div>
      )} */}
      {conversations?.map((chat) => (
        <div
          onClick={() => handleChatClick(chat)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleChatClick(chat);
            }
          }}
          role="button"
          tabIndex={0}
          className="relative flex items-center space-x-2 p-2 bg-white rounded-2xl mt-3 "
        >
          {chat?.unReadCount > 0 && !chat?.lastMessageFromMe ? (
            <span className="absolute top-0 right-0 bg-black text-white text-xs font-bold rounded-full h-6 w-6 transform flex justify-center items-center text-center translate-x-2 -translate-y-1">
              {chat?.unReadCount}
            </span>
          ) : (
            !chat?.lastMessageFromMe && (
              <span className="absolute top-0 right-0 bg-black text-white text-xs font-bold rounded-full h-6 w-6 transform flex justify-center items-center text-center translate-x-2 -translate-y-1" />
            )
          )}

          <div>
            {chat?.user ? (
              <img className="w-6 h-6 object-cover" src={handleImage(chat?.user?.cod_channel)} alt="John Smith" />
            ) : chat?.cleaner ? (
              <Iconify icon={'healthicons:domestic-worker-alt'} width={20} sx={{ cursor: 'pointer' }} />
            ) : (
              <img className="w-6 h-6 object-cover" src={whatsApp} alt="John Smith" />
            )}
            {/* <img className="w-6 h-6  object-cover" src={bnb} alt="John Smith" /> */}
          </div>
          {/* <div className="flex flex-1 flex-col gap-1 max-w-[100%]">
            <div className="flex  justify-between items-center">
              {chat?.user ? (
                <h4 className="font-bold text-gray-900">{chat?.user?.guestName}</h4>
              ) : (
                <h4 className="font-bold text-gray-900">{chat?.conversation_name || chat?.contactNo}</h4>
              )}
              <p className="text-[10px] ml-2 mr-4 text-gray-500 flex-shrink-0">
                {new Date(chat?.lastMessageTime).toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false,
                })}
              </p>
            </div> */}
          <div className="flex flex-1 flex-col gap-1 max-w-full">
            {/* <div className="flex flex-wrap justify-between items-center w-full">
              <h4 className="font-bold text-gray-900 min-w-0 break-words">
                {chat?.user ? chat?.user?.guestName : chat?.conversation_name || chat?.contactNo}
              </h4>

              <div className="flex flex-col items-end">
                <p className="text-xs text-gray-500">{chat?.contactNo}</p>
              </div>

              <p className="text-[10px] ml-2 text-gray-500 flex-shrink-0">
                {new Date(chat?.lastMessageTime).toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false,
                })}
              </p>
            </div> */}

            <div className=" w-full">
              {/* Left: Name */}
              <h4 className="font-bold text-gray-900 min-w-0 break-words">
                {chat?.user ? chat?.user?.guestName : chat?.conversation_name || chat?.contactNo}
              </h4>

              {/* Right: Contact No + Time in a row */}
              <div className="flex justify-between flex-wrap items-center gap-2 flex-shrink-0">
                <p className="text-xs text-gray-500">{chat?.contactNo}</p>
                <p className="text-[10px] text-gray-500">
                  {new Date(chat?.lastMessageTime).toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false,
                  })}
                </p>
              </div>
            </div>
            {/* </div> */}
            {chat?.user ? (
              <>
                <div>
                  <p className="text-sm text-gray-500">{chat?.user?.name_room_type}</p>
                  <p className="text-xs text-gray-400">
                    {chat?.user?.checkInDate} - {chat?.user?.checkOutDate}
                  </p>
                </div>
                <div className="flex gap-2">
                  <span
                    className={`${
                      handleStatus(chat?.user)?.bgColor
                    } w-20 text-center text-black text-[10px] font-thin px-1 py-0.5 rounded-2xl dark:text-white`}
                  >
                    {handleStatus(chat?.user)?.status}
                  </span>

                  {chat?.user?.manual_status && chat?.user?.manual_status !== 'none' && (
                    <span className="bg-[#FF6C6C] w-20 text-center text-black text-[10px] font-thin  px-1 py-0.5 rounded-2xl dark:bg-blue-900 dark:text-blue-300">
                      {chat?.user?.manual_status}
                    </span>
                  )}
                </div>
              </>
            ) : chat?.cleaner ? (
              <div className="flex gap-2">
                <span
                  className={`bg-red-500 w-20 text-center text-black text-[10px] font-thin px-1 py-0.5 rounded-2xl dark:text-white`}
                >
                  Cleaner
                </span>
              </div>
            ) : (
              <div className="flex gap-2">
                <span className="bg-[#FF97F8] w-20 text-center text-black text-[10px] font-thin  px-4 py-0.5 rounded-2xl dark:bg-blue-900 dark:text-blue-300">
                  Request
                </span>
              </div>
            )}
          </div>
        </div>
      ))}
      <div className="flex items-center justify-center mt-3">
        <Button variant="contained" size="small" onClick={handleLoadMore} disabled={loading || !hasMore}>
          {loading ? 'Loading...' : hasMore ? 'Load More' : 'No More Conversations'}
        </Button>
      </div>
    </div>
  );
};

export default Sidebar;
